export function drawStroke(ctx, stroke, width, height, color = '#30313b') {
  const points = stroke.points;
  if (!points.length) return;
  const thickness = stroke.width * height;
  ctx.strokeStyle = color;
  ctx.fillStyle = color;
  ctx.lineWidth = thickness;
  ctx.lineCap = 'round';
  ctx.lineJoin = 'round';
  ctx.beginPath();
  if (points.length === 1 || points.every(p => p.x === points[0].x && p.y === points[0].y)) {
    ctx.arc(points[0].x * width, points[0].y * height, thickness / 2, 0, Math.PI * 2);
    ctx.fill();
    return;
  }
  ctx.moveTo(points[0].x * width, points[0].y * height);
  for (let i = 1; i < points.length; i += 1) {
    ctx.lineTo(points[i].x * width, points[i].y * height);
  }
  ctx.stroke();
}

// Only ink is rendered here. Neither CSS guidelines nor UI text enters OCR.
// Crop and scale in physical coordinates, preserving the writing's aspect ratio.
export function buildOcrInput(strokes, size) {
  if (!strokes.length) return null;
  let left = Infinity, right = -Infinity, top = Infinity, bottom = -Infinity;
  for (const stroke of strokes) {
    const radius = stroke.width * size.height / 2;
    for (const p of stroke.points) {
      left = Math.min(left, p.x * size.width - radius);
      right = Math.max(right, p.x * size.width + radius);
      top = Math.min(top, p.y * size.height - radius);
      bottom = Math.max(bottom, p.y * size.height + radius);
    }
  }
  if (!Number.isFinite(left)) return null;
  const padding = Math.max(16, size.height * 0.06);
  left -= padding; top -= padding; right += padding; bottom += padding;
  const canvas = document.createElement('canvas');
  canvas.width = 1024; canvas.height = 384;
  const ctx = canvas.getContext('2d');
  if (!ctx) throw new Error('Bu tarayıcı yazı görüntüsünü hazırlayamıyor.');
  ctx.fillStyle = '#ffffff'; ctx.fillRect(0, 0, canvas.width, canvas.height);
  const scale = Math.min(924 / (right - left), 304 / (bottom - top));
  const ox = (canvas.width - (right - left) * scale) / 2;
  const oy = (canvas.height - (bottom - top) * scale) / 2;
  for (const stroke of strokes) {
    drawStroke(ctx, { width: stroke.width * size.height * scale / canvas.height,
      points: stroke.points.map(p => ({ x: (ox + (p.x * size.width - left) * scale) / canvas.width,
        y: (oy + (p.y * size.height - top) * scale) / canvas.height })) }, canvas.width, canvas.height, '#101010');
  }
  return canvas;
}
